import React from 'react';
import PropTypes from 'prop-types';

import SimpleModal from '@bufferapp/ui/SimpleModal';
import { Text, Button, Link } from '@bufferapp/ui';

import BulletPoint from '../bullet-point';
import { Content, Holder, Ctas, CtaText } from './styles';

function ConnectChannelModal(props) {
  const { closeModal, onConnectChannel } = props;

  return (
    <SimpleModal closeAction={closeModal}>
      <Holder>
        <Content>
          <Text type="h1">Get more out of Buffer</Text>
          <Text type="p">
            Connecting your channels is the first step to getting up and running
            with Buffer. Once you connect a channel, you’ll be able to:
          </Text>
          <ol>
            <BulletPoint text="Engage with comments" />
            <BulletPoint text="Schedule and publish content" />
            <BulletPoint text="Measure your social media performance" />
          </ol>
          <Ctas>
            <Button
              type="primary"
              onClick={() => onConnectChannel()}
              label="Connect channel"
            />
            <Button type="text" onClick={closeModal} label="Skip anyway" />
          </Ctas>
        </Content>
        <CtaText>
          <Text>
            Alternatively, you can{' '}
            <Link
              newTab
              href="https://start-page.buffer.com/?utm_source=publish-geid6"
            >
              build your Start Page
            </Link>{' '}
            before connecting any channels.
          </Text>
        </CtaText>
      </Holder>
    </SimpleModal>
  );
}

ConnectChannelModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onConnectChannel: PropTypes.func.isRequired,
};

export default ConnectChannelModal;
